import Marquee from "react-fast-marquee";

const ITEMS = [
  "ON THE COVER — Yumepai (@yumepaii) wears the crown — Atlanta's hyperpop-rave queen",
  "NEW ALBUM — Yumepai · 'Turned Chic' · streaming now on Spotify & Apple Music",
  "BREAKING — King Marlo's 'Crown Heavy' EP hits 5M streams",
  "EXCLUSIVE — Aria Vance closes Off-White Milan FW26",
  "PFC LIVE — Crown Heavy Tour tickets on sale now",
];

export default function BreakingTicker() {
  return (
    <div className="bg-ink-900 border-y border-pfc-gold/30 py-2.5 overflow-hidden" data-testid="breaking-ticker">
      <Marquee speed={45} gradient={false} pauseOnHover>
        {ITEMS.map((t) => (
          <span key={t} className="font-sub uppercase tracking-[0.25em] text-xs text-pfc-gold mx-12 flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-pfc-red rounded-full" />
            {t}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
